import React, { useState } from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';
import Spinner from '@tds/core-spinner';
import Button from '@tds/core-button';
import Modal from '@tds/community-modal';
import FileDownload from 'js-file-download';
import axios from 'axios';

import { ButtonWrapper } from './css';
import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';
import { apiHost, config } from '../../../../utils/request';

const ExportReport = ({ getPayload }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: {
      EXPORT,
      confirmationDialog,
      confirmationMessage,
      exportWarning,
      confirm,
      cancel
    }
  } = localizedStrings;

  const [isExporting, setIsExporting] = useState(false);
  const [showWarningMessage, setShowWarningMessage] = useState(false);

  const exportFile = async () => {
    try {
      setIsExporting(true);
      const result = await axios.post(
        `${apiHost}/orders/export/excel`,
        getPayload(),
        {
          ...config(),
          responseType: 'arraybuffer'
        }
      );
      if (result) {
        FileDownload(_.get(result, 'data', ''), 'orders.xlsx');
        setIsExporting(false);
      }
    } catch (error) {
      setIsExporting(false);
    }
  };

  const onClickExport = () => {
    const payload = getPayload();
    if (!payload.filterCriteria) {
      setShowWarningMessage(true);
    } else {
      exportFile();
    }
  };

  return (
    <>
      <ButtonWrapper>
        <Spinner
          label="Exporting Report..."
          size="small"
          spinning={isExporting}
          inline
        >
          <Button onClick={onClickExport}>{EXPORT}</Button>
        </Spinner>
      </ButtonWrapper>
      <Modal
        heading={confirmationDialog}
        bodyText={`${exportWarning} ${confirmationMessage}?`}
        confirmCTAText={confirm}
        cancelCTAText={cancel}
        onConfirm={() => {
          setShowWarningMessage(false);
          exportFile();
        }}
        onClose={() => {
          setShowWarningMessage(false);
        }}
        isOpen={showWarningMessage}
      />
    </>
  );
};

ExportReport.propTypes = {
  getPayload: PropTypes.func.isRequired
};

export default ExportReport;
